<template>
  <div class="bracket-final-match">
    <div v-if="title" class="bracket-final-match__title">{{ title }}</div>
    <div class="bracket-final-match__participants">
      <BracketFinalParticipant
        :participant="teams[match.team1]"
        :score="match.team1_score"
        :result="result"
      />
      <BracketFinalParticipant
        v-if="!result"
        :participant="teams[match.team2]"
        :score="match.team2_score"
      />
    </div>
  </div>
</template>

<script>
import BracketFinalParticipant from "./BracketFinalParticipant";

export default {
  name: "BracketFinalMatch",
  components: {
    BracketFinalParticipant
  },
  props: {
    result: Boolean,
    title: String,
    teams: {
      type: Object,
      required: true
    },
    match: {
      type: Object
    }
  }
};
</script>

<style lang="scss">
$p: ".bracket-final-match";
$border-color: #aabbd0;

.bracket-final-match {
  font-size: 12px;
  width: 180px;
  display: flex;
  flex: 1 0;
  flex-direction: column;

  &:not(:last-child) {
    margin-bottom: 4px;
  }

  &__title {
    font-size: 18px;
    text-transform: uppercase;
    color: colors(text-2);
    text-align: center;
    font-weight: fw(bold);
    height: 30px;
    background-color: colors(palette-1);
    margin-bottom: 4px;
    line-height: 30px;
    border-radius: 3px;
  }

  &__participants {
    position: relative;
    display: flex;
    flex: 1 0;
    flex-direction: column;
  }
}
</style>
